/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-04-25 22:12:01
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Button } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import CustomModal from './custom-modal';
import PersonalizationPresentBanner from 'src/assets/images/advance-search/personalization-present-banner.png';
import { getShop, nowTimestamp } from 'src/helpers';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { ENABLE_SEARCH_PERSONALIZATION_STORES } from 'src/constants/search';

type Props = {
  onDismiss: Function
};

type ComposedProps = Props & WithI18nProps;
type State = {
  showBanner: boolean
};

class SearchPersonalizationPresentModal extends Component<ComposedProps, State> {
  state = {
    showBanner: false
  };

  componentDidMount() {
    // Hide banner
    this.checkShowBanner();
  }

  render() {
    const { showBanner } = this.state;
    return (
      <CustomModal
        open={showBanner}
        className="SearchPersonalizationPresent-Popup-Container"
        clickBackdrop={this.onDismiss}>
        <div className="SearchPersonalizationPresent-Popup">
          <img
            src={PersonalizationPresentBanner}
            alt="Personalization Present Banner"
            usemap="#image_map"
            onClick={e => {
              e.preventDefault();
              this.openLink();
            }}
          />
          <map name="image_map">
            <area
              alt=""
              href=""
              title=""
              coords="326,452,491,495"
              shape="rect"
              onClick={e => {
                e.preventDefault();
                this.openLink();
              }}
            />
          </map>
          <div className="closeBtn">
            <Button onClick={this.onDismiss} icon={MobileCancelMajor} plain />
          </div>
        </div>
      </CustomModal>
    );
  }

  // Show banner status
  checkShowBanner = () => {
    const { tenantApp = {} } = this.props;
    const { tenantId = '' } = tenantApp;
    const now = nowTimestamp();
    const startDate = 1714608000; // 00:00:00, May 02, 2024
    const endDate = 1715385599; // 23:59:59, May 10, 2024
    const isShowTime = now >= startDate && now <= endDate;

    if (!isShowTime || !ENABLE_SEARCH_PERSONALIZATION_STORES.includes(tenantId)) {
      return;
    }

    try {
      // Get dismissed banner status
      const dismissedModal = localStorage.getItem(
        `${getShop()}-dismissSearchPersonalizationPresentModal`
      );

      if (dismissedModal !== 'true') {
        this.setState({ showBanner: true });
      }
    } catch (error) {}
  };

  // Handle hide banner
  onDismiss = () => {
    // Hide banner
    this.setState({ showBanner: false });

    // Set time
    try {
      localStorage.setItem(`${getShop()}-dismissSearchPersonalizationPresentModal`, true);
    } catch (error) {}
  };

  openLink = (id: string) => {
    history.push(routes.searchPersonalization.view());
    this.onDismiss();
  };
}

export default withI18n()(SearchPersonalizationPresentModal);
